define('helperNavigation-isSectionVisited',['helperContent-getEntity', 'helperNavigation-areChildrenVisited'], function(getEntity, areChildrenVisited) {
    'use strict';

    // Checks if page and all its sub paged visited
    var isSectionVisited = function f(eid, arr, user) {
        var entity, visited = true;

        if (!Array.isArray(arr)) {
            return null;
        }

        if(!user.isPageVisitedById(eid)){
            return false;
        }

        var entity = getEntity(eid, arr);

        if(!areChildrenVisited(entity.children, user)) return false;

        return true;
    };

    return isSectionVisited;
});

